import type { UserRole } from '@fleetops/types'

// Role hierarchy — higher index = more permissions
const ROLE_HIERARCHY: UserRole[] = ['viewer', 'operator', 'fleet_manager', 'tenant_admin', 'super_admin']

export function hasMinimumRole(userRole: UserRole, minimumRole: UserRole): boolean {
  return ROLE_HIERARCHY.indexOf(userRole) >= ROLE_HIERARCHY.indexOf(minimumRole)
}

export const can = {
  createDamage: (role: UserRole) => hasMinimumRole(role, 'operator'),
  updateDamage: (role: UserRole) => hasMinimumRole(role, 'operator'),
  deleteDamage: (role: UserRole) => hasMinimumRole(role, 'tenant_admin'),
  addComment: (role: UserRole) => hasMinimumRole(role, 'operator'),
  addEstimate: (role: UserRole) => hasMinimumRole(role, 'fleet_manager'),
  submitEstimate: (role: UserRole) => role === 'supplier',
  inviteSupplier: (role: UserRole) => hasMinimumRole(role, 'fleet_manager'),
  approveDamage: (role: UserRole) => hasMinimumRole(role, 'fleet_manager'),
  approveEstimate: (role: UserRole) => hasMinimumRole(role, 'fleet_manager'),
  manageUsers: (role: UserRole) => hasMinimumRole(role, 'tenant_admin'),
  manageFleets: (role: UserRole) => hasMinimumRole(role, 'fleet_manager'),
  manageSuppliers: (role: UserRole) => hasMinimumRole(role, 'fleet_manager'),
  viewSuppliers: (role: UserRole) => hasMinimumRole(role, 'operator') || role === 'supplier',
  manageAutoApproval: (role: UserRole) => hasMinimumRole(role, 'tenant_admin'),
  viewAllTenants: (role: UserRole) => role === 'super_admin',
  runChecklist: (role: UserRole) => hasMinimumRole(role, 'operator'),
  manageChecklists: (role: UserRole) => hasMinimumRole(role, 'fleet_manager'),
}
